<nav class="px-2 lg:px-8 border-b-2 border-primary border-b-accent bg-primary text-contrast">
  <div class="pt-2 pb-2">
    <div class="flex flex-col justify-center">
      <!-- Mobile menu toggle, controls the 'mobileMenuOpen' state. -->
      <div class="relative flex flex-row items-center">
        <button type="button" class="py-2 flex lg:hidden items-center text-primary-700" (click)="overlay.open()" aria-label="Menü">
          <ng-icon name="heroBars3" size="24px"></ng-icon>
        </button>
        <div class="flex ml-4 lg:ml-0 z-10 py-2">
          <a [routerLink]="['/']">
            <span class="sr-only">B&T Logo</span>
            <img class="h-16 w-auto" src="/assets/images/logo_white.svg" alt="" />
          </a>
          <div class="hidden md:ml-8 lg:block lg:self-stretch h-hull">
            <div class="flex h-full space-x-4">
              @for (item of nav.getMenuItems(); track item) {
                <a class="flex items-center text-sm font-medium" [routerLink]="item.routerLink">{{ item.text | i18n }}</a>
              }
            </div>
          </div>
        </div>

        <div class="ml-auto flex items-center">
          <div class="flex flex-row items-center ml-6">
            <!-- <button
              class="flex flex-row cursor-pointer p-2 text-gray-400 hover:text-primary-700"
              (click)="BbitI18n.setLanguage(BbitLanguage.DE_CH)"
            >
              DE
            </button>

            <button
              class="flex flex-row cursor-pointer p-2 text-gray-400 hover:text-primary-700"
              (click)="BbitI18n.setLanguage(BbitLanguage.EN_US)"
            >
              EN
            </button>

            <button
              class="flex flex-row cursor-pointer p-2 text-gray-400 hover:text-primary-700 mr-2"
              (click)="BbitI18n.setLanguage(BbitLanguage.FR_CH)"
            >
              FR
            </button> -->

            @if (!(website.observeAuthenticated() | async)) {
              <button
                (click)="website.login()"
                class="flex max-w-xs flex-1 items-center justify-center border border-transparent bg-contrast text-primary-600 py-2 pl-2 pr-4 text-sm font-medium hover:bg-primary-700 hover:text-contrast focus:outline-none focus:ring-2 focus:ring-primary-700 focus:ring-offset-2 focus:ring-offset-gray-50 sm:w-full"
              >
                <ng-icon name="heroArrowLeftOnRectangle" class="flex-shrink-0 mr-1" size="24px"></ng-icon>
                Login
              </button>
            } @else {
              <a [routerLink]="['/account']" class="flex flex-row p-2 text-gray-400 hover:text-contrast">
                <ng-icon name="heroUserCircle" class="flex-shrink-0" size="24px"></ng-icon>
              </a>
              <button class="flex flex-row cursor-pointer p-2 text-gray-400 hover:text-contrast" (click)="website.logout()">
                <ng-icon name="heroArrowRightOnRectangle" class="flex-shrink-0" size="24px"></ng-icon>
              </button>
            }
          </div>
        </div>
      </div>
    </div>
  </div>
</nav>
